/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_6Inputs */

const en_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center right`)
};

const fr_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre droit`)
};

const de_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte rechts`)
};

const it_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiamata al centro`)
};

const ru_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центр справа`)
};

const es_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro derecha`)
};

const zh_cn2_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中右`)
};

const ja_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央右`)
};

const hi_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र दाएँ`)
};

const pt_pt2_live_caption_youtube_region_6 = /** @type {(inputs: Live_Caption_Youtube_Region_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro-direita`)
};

/**
* | output |
* | --- |
* | "Center right" |
*
* @param {Live_Caption_Youtube_Region_6Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_6 = /** @type {((inputs?: Live_Caption_Youtube_Region_6Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_6Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region_6(inputs)
	if (locale === "de") return de_live_caption_youtube_region_6(inputs)
	if (locale === "it") return it_live_caption_youtube_region_6(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region_6(inputs)
	if (locale === "es") return es_live_caption_youtube_region_6(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region_6(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region_6(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region_6(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region_6(inputs)
	return en_live_caption_youtube_region_6(inputs)
});